<template>
  <div class="inputdata">
    <div class="input-info">
      <input
        ref="inputdata"
        type="text"
        :value="value"
        @blur="inputBlur($event)"
        @input="changInput($event)"
        :placeholder="placeholder"
      />
      <slot></slot>
    </div>
    <div class="input-state" v-show="stateShow">
      <span>{{ stateTitle }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["placeholder", "value", "stateTitle"],
  data() {
    return {
      stateShow: false,
    };
  },
  methods: {
    inputBlur(e) {
      if (!e.target.value) {
        this.$refs["inputdata"].style.borderColor = "red";
        this.stateShow = true;
      } else {
        this.$refs["inputdata"].style.borderColor = "#cccccc";
        this.stateShow = false;
      }
    },
    changInput(e) {
      this.$emit("input", e.target.value);
    },
    setinputstate() {
      this.$refs["inputdata"].style.borderColor = "red";
      this.stateShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.inputdata {
  position: relative;
  width: 100%;
  height: auto;
  .input-info {
    width: 100%;
    height: 0.37rem;
    position: relative;
    display: flex;
    align-items: center;
    input {
      width: 100%;
      height: 0.37rem;
      text-indent: 0.1rem;
      font-size: 0.1rem;
      font-weight: 400;
      color: #444444;
      background-color: #fff;
      background-image: none;
      border-radius: 0.18rem;
      border: 1px solid #cccccc;
      box-sizing: border-box;
      outline: none;
      &::-webkit-input-placeholder {
        color: #cccccc;
      }
      input::-moz-input-placeholder {
        color: #cccccc;
      }
      input::-ms-input-placeholder {
        color: #cccccc;
      }
      &:focus {
        border-color: #50bbe5;
      }
    }
  }

  .input-state {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 0.1rem;
    color: red;
    margin-top: 0.42rem;
  }
}
</style>
